import { IChoiceGroupOption } from '@fluentui/react';

export const EnteredManuallySentToR3Options: IChoiceGroupOption[] = [
  { key: 'enteredManually', text: 'Entered Manually' },
  { key: 'sentToR3', text: 'Send to SAP' },
];